import { render, staticRenderFns } from "./NewYear.vue?vue&type=template&id=ca745cca&scoped=true&"
import script from "./NewYear.vue?vue&type=script&lang=js&"
export * from "./NewYear.vue?vue&type=script&lang=js&"
import style0 from "./NewYear.vue?vue&type=style&index=0&id=ca745cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca745cca",
  null
  
)

export default component.exports